import axios, { type AxiosInstance } from 'axios';

export function getApiHost(): string {
  return process.env.REACT_APP_API_HOST || '';
}

export function getAdminAppHost(): string {
  return (process.env.REACT_APP_ADMIN_HOST || 'http://localhost:5101').replace(
    /\/+$/,
    '',
  );
}

/** Plain admin entry — session is the HttpOnly API cookie, not a URL token. */
export function getAdminSignInUrl(): string {
  return `${getAdminAppHost()}/login/sign-in`;
}

type UnauthorizedHandler = () => void;

let unauthorizedHandler: UnauthorizedHandler | null = null;

export function setUnauthorizedHandler(handler: UnauthorizedHandler): void {
  unauthorizedHandler = handler;
}

function attachUnauthorizedInterceptor(client: AxiosInstance): AxiosInstance {
  client.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error?.response?.status === 401) {
        unauthorizedHandler?.();
      }
      return Promise.reject(error);
    },
  );
  return client;
}

export function createPublicClient(): AxiosInstance {
  return axios.create({
    baseURL: getApiHost(),
    withCredentials: true,
    headers: {
      'Content-Type': 'application/json',
    },
  });
}

export function createAuthClient(accessToken?: string): AxiosInstance {
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
  };
  if (accessToken) {
    headers.Authorization = accessToken.startsWith('Bearer ')
      ? accessToken
      : `Bearer ${accessToken}`;
  }
  return attachUnauthorizedInterceptor(
    axios.create({
      baseURL: getApiHost(),
      withCredentials: true,
      headers,
    }),
  );
}
